import React from 'react'
import { QuizQuestionWrapper } from '../../QuizQuestionWrapper'
import { useNewPlanningStage } from './NewPlanningStage.hook'
import { NEW_STAGES, QuizType } from 'src/pages/shared'
import { RadioWithIcon } from 'src/common/components/input/RadioWithIcon'
import './NewPlanningStage.scss'
import { useLocation } from 'react-router-dom'

const disabledDays = new Date()
disabledDays.setDate(disabledDays.getDate() + 1)

export const NewPlanningStage = () => {
  const query = new URLSearchParams(useLocation().search)
  const isPinterestFlow = query.get('quizType') === QuizType.PINTEREST
  const { handleBack, stage, handleChangeStage, handleClickStage } = useNewPlanningStage(
    query.get('quizType') as QuizType
  )

  return (
    <>
      <QuizQuestionWrapper
        showBgFlower
        titleStep="PLANNING"
        title={
          <>
            Where are you at in <i>floral planning?</i>
          </>
        }
        nextAction={{
          disabled: true,
        }}
        backAction={{
          onAction: handleBack,
        }}
        customCss={{
          title: 'title-bold',
          content: 'new-planning-stage-wrapper',
        }}
        step={4}
        total={7}
        className={isPinterestFlow ? 'pinterest-flow planning-stage' : ''}
        quizType={query.get('quizType') as QuizType}
      >
        <div className="new-planning-stage-section">
          {NEW_STAGES.map((item) => (
            <RadioWithIcon
              key={item.value}
              id={item.value}
              value={item.value}
              name="planning"
              classNames={{ container: '', label: 'basic' }}
              checked={stage === item.value}
              onChange={handleChangeStage}
              onClick={() => handleClickStage(item.value)}
            >
              {item.label}
            </RadioWithIcon>
          ))}
        </div>
      </QuizQuestionWrapper>
    </>
  )
}
